import { render, staticRenderFns } from "./ProductCanvas.vue?vue&type=template&id=bfb61c7a"
import script from "./ProductCanvas.vue?vue&type=script&lang=js"
export * from "./ProductCanvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports